<template>
  <div>
    <layout menu-item="2">
      <div  class="inner-container">
        <input type="checkbox" style="margin-bottom: 1rem" ref="autoSort" checked @change="sortCities"/> Nach Datum sortieren
        <div v-for="city in cities" v-if="loaded">
          <city
            class="city"
            :data="city"
            :selected="city.isActive"
            @onSelected="onSelected"
            @onStartDateChanged="onStartDateChanged"
            @onEndDateChanged="onEndDateChanged"
            @onAddressChanged="onAddressChanged"
            @onPositionChanged="onPositionChanged"
          />
        </div>
      </div>
    </layout>
  </div>
</template>

<script>

  import Backend from '@/Backend';
  import City from "./City";
  import moment from 'moment';

  export default {
    components: {City},
    name: "cities",
    data() {
      return {
        loaded: false,
        currentSelectedCity: null,
        cities: []
      }
    },
    mounted() {
      Backend.instance.getCities()
        .then((data) => {
          this.loaded = true;
          this.cities = data;
          for (let i = 0; i < data.length; i++) {
            const entry = data[i];
            if (entry.isActive) {
              this.currentSelectedCity = entry;

            }
            entry._start = moment(entry.startDate).valueOf();
          }

          this.sortCities();

        })
        .catch((e) => {

        });
    },
    methods: {
      sortCities() {
        if (!this.$refs.autoSort.checked) return;
        this.cities.sort((a, b) => {
          return a._start - b._start;
        });
      },
      onSelected(data) {


        const n = confirm(`Die ausgewählte Stadt ${data == this.currentSelectedCity ? 'deaktivieren' : 'aktivieren'}?`);
        if (!n) return;

        if (this.currentSelectedCity) {
          this.currentSelectedCity.isActive = false;
          Backend.instance.activateCity(this.currentSelectedCity._id, false);
        }

        if (data != this.currentSelectedCity) {
          data.isActive = true;
          this.currentSelectedCity = data;
          Backend.instance.activateCity(this.currentSelectedCity._id, true);
        }
      },
      onStartDateChanged(data, value) {
        const m = moment(value);
        data.startDate = m.toISOString();
        data._start = moment(value).valueOf();
        Backend.instance.changeCityDate(data._id, data._start, 0);

          this.sortCities();
      },
      onEndDateChanged(data, value) {
        const m = moment(value);
        data.endDate = m.toISOString();
        data._end = moment(value).valueOf();
        Backend.instance.changeCityDate(data._id, data._end, 1);
      },

      onAddressChanged(data, a1, a2, a3) {
        console.log('change address', a1, a2, a3);
        Backend.instance.changeCityAddresses(data._id, a1, a2, a3);
      },

      onPositionChanged(data, top, left) {
        Backend.instance.changeCityPosition(data._id, top, left);
      }
    }
  }
</script>

<style scoped>
.city {

}
</style>



// WEBPACK FOOTER //
// src/components/cities/Cities.vue